import React, { useCallback, useRef } from 'react';

import { AnchorLink } from "gatsby-plugin-anchor-links";

import {openModal} from '../utils/Modal'
import ModalJob from './ModalJob';

import Slider from 'react-slick';

const FeaturedJobs = () => {

  const jobSliderLeft = useRef();
  const jobSliderRight = useRef();

  const jobSliderPause = useCallback(() => {
    if (jobSliderLeft.current && jobSliderRight.current) {
      jobSliderLeft.current.slickPause();
      jobSliderRight.current.slickPause();
    }
  }, []);
  const jobSliderPlay = useCallback(() => {
    if (jobSliderLeft.current && jobSliderRight.current) {
      jobSliderLeft.current.slickPlay();
      jobSliderRight.current.slickPlay();
    }
  }, []);

  return (
    <section className="featured-jobs position-relative">
      <span className="big-gradient-circle gradient-anim " />
      <span className="big-gradient-circle small-gradient red-gradient gradient-anim delay-1" />
      <div >
        <h5 className="yellow-heading text-center">Featured jobs</h5>
        <h3 className="text-center">Find the best jobs around the world</h3>
        <div className="slider-container-1" onMouseEnter={jobSliderPause} onMouseLeave={jobSliderPlay}>
          <Slider
            ref={jobSliderLeft}
            dots={false}
            arrows={false}
            pauseOnHover={false}
            infinite
            slidesToShow={3}
            slidesToScroll={0.25}
            speed={1000}
            autoplaySpeed={100}
            autoplay
            cssEase="linear"
            responsive={[
              {
                breakpoint: 1441,
                settings: {
                  slidesToShow: 2.6,
                },
              },
              {
                breakpoint: 1300,
                settings: {
                  slidesToShow: 2,
                },
              },
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 1.5,
                },
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1.6,
                },
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1.4,
                },
              },
              {
                breakpoint: 500,
                settings: {
                  slidesToShow: 1.1,
                },
              },
              {
                breakpoint: 380,
                settings: {
                  slidesToShow: 0.9,
                },
              },
              ]}
          >
            <div>
              <button className="job-card" onClick={() => openModal(<ModalJob />)}>
                <div className="flex-row no-margin align-items-center mb-15">
                  <img src="/img/jobs/google.svg" alt="" className="job-logo"/>
                  <div className="job-heading">
                    <h4>Product Manager</h4>
                    <p className="job-detail">Google &#183; Remote friendly &#183; Full-time</p>
                  </div>
                </div>
                <div className="flex-row align-items-center">
                  <p className="tag salary">
                    <img src="/img/jobs/salary-icon.svg" alt=""/>
                    1,00,000 - 2,20,000
                  </p>
                  <p className="tag location">
                    <img src="/img/jobs/location-icon.svg" alt=""/>
                    London, UK
                  </p>
                  <p className="tag experience">
                    <img src="/img/jobs/experience-icon.svg" alt=""/>
                    02+ years
                  </p>
                  <p className="tag opening">
                    <img src="/img/jobs/opening-icon.svg" alt=""/>
                    06 Openings
                  </p>
                </div>
              </button>
            </div>
            <div>
              <button className="job-card" onClick={() => openModal(<ModalJob />)}>
                <div className="flex-row no-margin align-items-center mb-15">
                  <img src="/img/jobs/google.svg" alt="" className="job-logo"/>
                  <div className="job-heading">
                    <h4>Product Manager</h4>
                    <p className="job-detail">Google &#183; Remote friendly &#183; Full-time</p>
                  </div>
                </div>
                <div className="flex-row align-items-center">
                  <p className="tag salary">
                    <img src="/img/jobs/salary-icon.svg" alt=""/>
                    1,00,000 - 2,20,000
                  </p>
                  <p className="tag location">
                    <img src="/img/jobs/location-icon.svg" alt=""/>
                    London, UK
                  </p>
                  <p className="tag experience">
                    <img src="/img/jobs/experience-icon.svg" alt=""/>
                    02+ years
                  </p>
                  <p className="tag opening">
                    <img src="/img/jobs/opening-icon.svg" alt=""/>
                    06 Openings
                  </p>
                </div>
              </button>
            </div>
            <div>
              <button className="job-card" onClick={() => openModal(<ModalJob />)}>
                <div className="flex-row no-margin align-items-center mb-15">
                  <img src="/img/jobs/google.svg" alt="" className="job-logo"/>
                  <div className="job-heading">
                    <h4>Product Manager</h4>
                    <p className="job-detail">Google &#183; Remote friendly &#183; Full-time</p>
                  </div>
                </div>
                <div className="flex-row align-items-center">
                  <p className="tag salary">
                    <img src="/img/jobs/salary-icon.svg" alt=""/>
                    1,00,000 - 2,20,000
                  </p>
                  <p className="tag location">
                    <img src="/img/jobs/location-icon.svg" alt=""/>
                    London, UK
                  </p>
                  <p className="tag experience">
                    <img src="/img/jobs/experience-icon.svg" alt=""/>
                    02+ years
                  </p>
                  <p className="tag opening">
                    <img src="/img/jobs/opening-icon.svg" alt=""/>
                    06 Openings
                  </p>
                </div>
              </button>
            </div>
            <div>
              <button className="job-card" onClick={() => openModal(<ModalJob />)}>
                <div className="flex-row no-margin align-items-center mb-15">
                  <img src="/img/jobs/google.svg" alt="" className="job-logo"/>
                  <div className="job-heading">
                    <h4>Product Manager</h4>
                    <p className="job-detail">Google &#183; Remote friendly &#183; Full-time</p>
                  </div>
                </div>
                <div className="flex-row align-items-center">
                  <p className="tag salary">
                    <img src="/img/jobs/salary-icon.svg" alt=""/>
                    1,00,000 - 2,20,000
                  </p>
                  <p className="tag location">
                    <img src="/img/jobs/location-icon.svg" alt=""/>
                    London, UK
                  </p>
                  <p className="tag experience">
                    <img src="/img/jobs/experience-icon.svg" alt=""/>
                    02+ years
                  </p>
                  <p className="tag opening">
                    <img src="/img/jobs/opening-icon.svg" alt=""/>
                    06 Openings
                  </p>
                </div>
              </button>
            </div>
            <div>
              <button className="job-card" onClick={() => openModal(<ModalJob />)}>
                <div className="flex-row no-margin align-items-center mb-15">
                  <img src="/img/jobs/google.svg" alt="" className="job-logo"/>
                  <div className="job-heading">
                    <h4>Product Manager</h4>
                    <p className="job-detail">Google &#183; Remote friendly &#183; Full-time</p>
                  </div>
                </div>
                <div className="flex-row align-items-center">
                  <p className="tag salary">
                    <img src="/img/jobs/salary-icon.svg" alt=""/>
                    1,00,000 - 2,20,000
                  </p>
                  <p className="tag location">
                    <img src="/img/jobs/location-icon.svg" alt=""/>
                    London, UK
                  </p>
                  <p className="tag experience">
                    <img src="/img/jobs/experience-icon.svg" alt=""/>
                    02+ years
                  </p>
                  <p className="tag opening">
                    <img src="/img/jobs/opening-icon.svg" alt=""/>
                    06 Openings
                  </p>
                </div>
              </button>
            </div>
          </Slider>
          <Slider
            ref={jobSliderRight}
            dots={false}
            arrows={false}
            pauseOnHover={false}
            infinite
            slidesToShow={3}
            slidesToScroll={0.25}
            speed={1000}
            autoplaySpeed={100}
            autoplay
            cssEase="linear"
            rtl
            responsive={[
              {
                breakpoint: 1441,
                settings: {
                  slidesToShow: 2.6,
                },
              },
              {
                breakpoint: 1300,
                settings: {
                  slidesToShow: 2,
                },
              },
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 1.5,
                },
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1.6,
                },
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1.4,
                },
              },
              {
                breakpoint: 500,
                settings: {
                  slidesToShow: 1.1,
                },
              },
              {
                breakpoint: 380,
                settings: {
                  slidesToShow: 0.9,
                },
              },
              ]}
          >
            <div>
              <button className="job-card" onClick={() => openModal(<ModalJob />)}>
                <div className="flex-row no-margin align-items-center mb-15">
                  <img src="/img/jobs/google.svg" alt="" className="job-logo"/>
                  <div className="job-heading">
                    <h4>Product Manager</h4>
                    <p className="job-detail">Google &#183; Remote friendly &#183; Full-time</p>
                  </div>
                </div>
                <div className="flex-row align-items-center">
                  <p className="tag salary">
                    <img src="/img/jobs/salary-icon.svg" alt=""/>
                    1,00,000 - 2,20,000
                  </p>
                  <p className="tag location">
                    <img src="/img/jobs/location-icon.svg" alt=""/>
                    London, UK
                  </p>
                  <p className="tag experience">
                    <img src="/img/jobs/experience-icon.svg" alt=""/>
                    02+ years
                  </p>
                  <p className="tag opening">
                    <img src="/img/jobs/opening-icon.svg" alt=""/>
                    06 Openings
                  </p>
                </div>
              </button>
            </div>
            <div>
              <button className="job-card" onClick={() => openModal(<ModalJob />)}>
                <div className="flex-row no-margin align-items-center mb-15">
                  <img src="/img/jobs/google.svg" alt="" className="job-logo"/>
                  <div className="job-heading">
                    <h4>Product Manager</h4>
                    <p className="job-detail">Google &#183; Remote friendly &#183; Full-time</p>
                  </div>
                </div>
                <div className="flex-row align-items-center">
                  <p className="tag salary">
                    <img src="/img/jobs/salary-icon.svg" alt=""/>
                    1,00,000 - 2,20,000
                  </p>
                  <p className="tag location">
                    <img src="/img/jobs/location-icon.svg" alt=""/>
                    London, UK
                  </p>
                  <p className="tag experience">
                    <img src="/img/jobs/experience-icon.svg" alt=""/>
                    02+ years
                  </p>
                  <p className="tag opening">
                    <img src="/img/jobs/opening-icon.svg" alt=""/>
                    06 Openings
                  </p>
                </div>
              </button>
            </div>
            <div>
              <button className="job-card" onClick={() => openModal(<ModalJob />)}>
                <div className="flex-row no-margin align-items-center mb-15">
                  <img src="/img/jobs/google.svg" alt="" className="job-logo"/>
                  <div className="job-heading">
                    <h4>Product Manager</h4>
                    <p className="job-detail">Google &#183; Remote friendly &#183; Full-time</p>
                  </div>
                </div>
                <div className="flex-row align-items-center">
                  <p className="tag salary">
                    <img src="/img/jobs/salary-icon.svg" alt=""/>
                    1,00,000 - 2,20,000
                  </p>
                  <p className="tag location">
                    <img src="/img/jobs/location-icon.svg" alt=""/>
                    London, UK
                  </p>
                  <p className="tag experience">
                    <img src="/img/jobs/experience-icon.svg" alt=""/>
                    02+ years
                  </p>
                  <p className="tag opening">
                    <img src="/img/jobs/opening-icon.svg" alt=""/>
                    06 Openings
                  </p>
                </div>
              </button>
            </div>
            <div>
              <button className="job-card" onClick={() => openModal(<ModalJob />)}>
                <div className="flex-row no-margin align-items-center mb-15">
                  <img src="/img/jobs/google.svg" alt="" className="job-logo"/>
                  <div className="job-heading">
                    <h4>Product Manager</h4>
                    <p className="job-detail">Google &#183; Remote friendly &#183; Full-time</p>
                  </div>
                </div>
                <div className="flex-row align-items-center">
                  <p className="tag salary">
                    <img src="/img/jobs/salary-icon.svg" alt=""/>
                    1,00,000 - 2,20,000
                  </p>
                  <p className="tag location">
                    <img src="/img/jobs/location-icon.svg" alt=""/>
                    London, UK
                  </p>
                  <p className="tag experience">
                    <img src="/img/jobs/experience-icon.svg" alt=""/>
                    02+ years
                  </p>
                  <p className="tag opening">
                    <img src="/img/jobs/opening-icon.svg" alt=""/>
                    06 Openings
                  </p>
                </div>
              </button>
            </div>
            <div>
              <button className="job-card" onClick={() => openModal(<ModalJob />)}>
                <div className="flex-row no-margin align-items-center mb-15">
                  <img src="/img/jobs/google.svg" alt="" className="job-logo"/>
                  <div className="job-heading">
                    <h4>Product Manager</h4>
                    <p className="job-detail">Google &#183; Remote friendly &#183; Full-time</p>
                  </div>
                </div>
                <div className="flex-row align-items-center">
                  <p className="tag salary">
                    <img src="/img/jobs/salary-icon.svg" alt=""/>
                    1,00,000 - 2,20,000
                  </p>
                  <p className="tag location">
                    <img src="/img/jobs/location-icon.svg" alt=""/>
                    London, UK
                  </p>
                  <p className="tag experience">
                    <img src="/img/jobs/experience-icon.svg" alt=""/>
                    02+ years
                  </p>
                  <p className="tag opening">
                    <img src="/img/jobs/opening-icon.svg" alt=""/>
                    06 Openings
                  </p>
                </div>
              </button>
            </div>
          </Slider>
        </div>
        <AnchorLink to="/jobs/#jobs" className="button button-purple">
          Explore All Jobs
        </AnchorLink>
      </div>
    </section>
  );
};

export default FeaturedJobs;
